import DashboardHeader from '../components/mainDashboard/DashboardHeader';
import UserProfileInfo from '../components/userProfile/UserProfileInfo';
import UserResetPassword from '../components/userProfile/UserResetPassword';

import './UserProfilePage.scss';

const UserProfilePage = () => {
	return (
		<div className='user-profile-main-container'>
			<DashboardHeader />
			<UserProfileInfo />
			<UserResetPassword />
		</div>
	);
};

export default UserProfilePage;
